import editor from "./MicroCreditProductEditor";
import service from "./MicroCreditProductService";
import BaseProductLoadPageMixin from "@/modules/core/product/protected/BaseProductLoadPageMixin";

export default {
  mixins: [BaseProductLoadPageMixin],

  components: {
    editor
  },

  methods: {
    getService() {
      return service;
    }
  }
};
